import React from 'react'
import "../css/Experince.css";

function Experince({company,role,desc,logo}) {

  let descArr = desc.split(",")
  return (
    <div className='expContainer'>
        
        <div className='ExperinceSec'>
        {/* <h1>Experince</h1>

         */}

      <div className='lineContainer'>
        
       <div className='circle'></div>
       <div className="line">
        
       </div>
      </div>   

     
      <img className='companyLogo' src={logo} alt="" srcset="" />
     <div className="right">
     
     <h3 className='companyName'>{company}</h3>
       <p className='role'>{role}</p> 
       {descArr.map(text=> <li className='desc'>{text}</li>)}
      
       
       
     </div>
       
    </div>

    </div>
    
  )
}

export default Experince